import { promoChange, promoToggleModalVisibility } from 'actions/promos'
import { redirect } from 'actions/redirect'
import { trackGetStarted } from 'actions/tracking'
import { isOptimizelyFeatureEnabledFactory } from 'containers/OptimizelyRollouts'
import { getPromoBannerState } from 'routes/Home/homeUtils'
import logger from 'utils/logger'

const getIsTestAllocationFactoryEnabled = isOptimizelyFeatureEnabledFactory(
  'beetroots_test_allocation_factory_web',
)

const getIsNewReducedPromoCodeEnabled = isOptimizelyFeatureEnabledFactory(
  'beetroots_new_reduced_promocode_web_enabled',
)

export const applyPromoCodeAndShowModal = () => async (dispatch, getState) => {
  const state = getState()

  const isNewReducedPromoCodeEnabled = await getIsNewReducedPromoCodeEnabled(dispatch, getState)

  const { promoCode, canApplyPromo } = getPromoBannerState(state, isNewReducedPromoCodeEnabled)

  if (!canApplyPromo) {
    return
  }

  try {
    await dispatch(promoChange(promoCode))
  } catch (err) {
    logger.warning(`error fetching promo code ${promoCode} - ${err.message}`, err)

    return
  }

  dispatch(promoToggleModalVisibility(true))
}

export const homeGetStarted = (ctaUri, sectionForTracking) => async (dispatch, getState) => {
  if (sectionForTracking) {
    dispatch(trackGetStarted(sectionForTracking))
  }

  await dispatch(applyPromoCodeAndShowModal())

  dispatch(redirect(ctaUri))

  const isTestAllocationFactoryEnabled = await getIsTestAllocationFactoryEnabled(dispatch, getState)
  logger.info(`beetroots_test_allocation_factory_web=${isTestAllocationFactoryEnabled}`)
}

export const homeActions = {
  homeGetStarted,
  applyPromoCodeAndShowModal,
}
